import { render, staticRenderFns } from "./pollRes.vue?vue&type=template&id=d2b35ab2&scoped=true&"
import script from "./pollRes.vue?vue&type=script&lang=js&"
export * from "./pollRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b35ab2",
  null
  
)

export default component.exports